__turbopack_context__.v({
  "button": "_14_aJq_button",
  "content": "_14_aJq_content",
  "placeholder": "_14_aJq_placeholder",
  "section": "_14_aJq_section",
  "title": "_14_aJq_title",
});
